// Abu Dhabi - full price list. Framed around whole-villa costs.
const content = {
    slug: 'ac-service-price',
    title: (c) => `AC Service Price in Abu Dhabi | Per Unit & Whole-Villa Costs`,
    description: (c) =>
        `AC service prices in Abu Dhabi: cleaning from ${c.money(c.tables.general[0].wall)}, coil wash ${c.money(c.tables.chemicalWash[0].wall)}, gas, repair and yearly plans.`,
    eyebrow: 'Abu Dhabi · Price list',
    h1: 'AC Service Prices in Abu Dhabi',
    lead: (c) =>
        `What AC service actually costs per unit - and for a whole villa. Example: cleaning five split units costs ${c.money(c.tables.general[4].wall)} in one visit, about ${c.money(c.tables.general[4].perUnitWall)} per unit.`,
    image: 'aircon-front.jpg',
    imageAlt: 'Front view of a wall-mounted AC unit',
    facts: ['All prices in AED', 'No call-out fee', 'Villa examples'],
    ctaLabel: 'See all prices',
    priceTitle: 'Full price list',
    priceIntro: '"Ducted" means a concealed ducted unit above the ceiling. Prices fall per unit as you add units.',
    // Hero tiles open on split units, matching this page's villa examples
    // (Dubai's price page opens on ducted, the apartment default).
    panel: { type: 'priceTable', defaultMount: 'Wall' },
    sections: [
        {
            title: 'What a year of AC care costs for a typical villa',
            cards: [
                { title: '3-bedroom townhouse, 4 units', body: (c) => `Three cleanings a year cost ${c.money(c.tables.annual[3].threeTimes)} on a yearly plan. Add one coil wash for all four units each spring for ${c.money(c.tables.chemicalWash[3].wall)}.` },
                { title: '5-bedroom villa, 5+ units', body: (c) => `A yearly plan with three visits costs ${c.money(c.tables.annual[4].threeTimes)} for five units. Larger villas are quoted per extra unit at the same rate.` },
                { title: 'Island apartment, 2 ducted units', body: (c) => `Cleaning both units costs ${c.money(c.tables.general[1].ducted)} per visit; a coil wash for both costs ${c.money(c.tables.chemicalWash[1].ducted)}.` },
            ],
        },
        {
            title: 'Same price on the islands and the mainland',
            paragraphs: [
                'A cleaning on Yas or Saadiyat costs the same as one in Khalifa City or Al Reef - there is no island surcharge and no extra for gated communities. What changes the total is the number and type of units, not the postcode.',
                'Where Abu Dhabi homes differ is in what they need. Island apartments usually need their coils washed more often because of humidity; mainland villas need outdoor units cleared of sand. The technician points this out on the first visit so you can plan the year rather than react to breakdowns.',
            ],
        },
        {
            title: 'When paying more makes sense',
            cards: [
                { title: 'Musty smell that keeps returning', body: 'Skip repeated cleanings and book a coil chemical wash - it costs more once but fixes the cause.' },
                { title: 'Old unit losing gas every summer', body: 'Pay for a leak repair rather than another top-up; for R22 units, compare against the cost of a new unit.' },
                { title: 'Villa with six or more units', body: 'A yearly plan costs more upfront than a single visit, but less than booking three visits a year separately.' },
            ],
        },
        {
            title: 'Our prices and the market',
            tone: 'muted',
            paragraphs: [
                'Advertised split-unit cleaning in the UAE usually costs AED 150 to AED 250 per unit, and deep coil cleaning on ducted units commonly AED 400 or more. Our prices sit below those ranges while we grow in Abu Dhabi, and include travel.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much does it cost to service all the ACs in a villa?',
            answer: (c) => `A cleaning for five split units costs ${c.money(c.tables.general[4].wall)} in one visit. Ducted villas cost more per unit; use the table above for your mix of units.`,
        },
        {
            question: 'Is a yearly plan cheaper?',
            answer: (c) => `Yes. For one unit, three visits a year cost ${c.money(c.tables.annual[0].threeTimes)} on a plan, versus ${c.money(c.tables.general[0].wall * 3)} booked separately.`,
        },
    ],
    schema: {
        name: 'AC Service Prices in Abu Dhabi',
        serviceType: 'Air conditioner servicing',
        offers: (c) => [
            { name: 'AC cleaning, 1 split unit', price: c.tables.general[0].wall },
            { name: 'AC cleaning, 5 split units', price: c.tables.general[4].wall },
            { name: 'Coil chemical wash, 1 split unit', price: c.tables.chemicalWash[0].wall },
            { name: 'Yearly plan, 1 unit, 3 visits', price: c.tables.annual[0].threeTimes },
            { name: 'Repair diagnosis visit', price: c.tables.repairDiagnosis },
        ],
    },
}

export default content
